module.exports = __webpack_public_path__ + "img/Icon-ArrowDropDown-Filled-gray.cbca424a.svg";